import React from 'react';
import styled from 'styled-components';
import Activity from './Activity';
import Alerts from './Alerts';
import Objectives from './Objectives';

const MainTopObj = styled.div`
                        background: #E5E5E9;
                        width:100%;
                        min-height: 200px;

`;

function MainTop(props) {
    return (
        <div className="container">

            <div className="row mb-3">
                <div className="col-12">
                    <MainTopObj>
                        <Objectives objectives={props.objectives} departments={props.departments} />
                    </MainTopObj>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-sm-12 col-lg-6">
                    <Activity />
                </div>
                <div className="col-sm-12 col-lg-6">
                    <Alerts />
                </div>
            </div>


        </div>
    );
}

export default MainTop;